export default __webpack_public_path__ + "static/media/ic-crops-forages.3d9094a2.svg";